import { ItemData } from 'core/models/Template'

export const QUIZ_CATALOG_TYPE = 'quiz' as const

export const QUIZ_CATALOG_CONFIG = {
    type: QUIZ_CATALOG_TYPE,
    fixedHeader: true,
    isExistRightToolbar: false,
    treeView: false,
    hideHeader: true,
} as const

export type QuizSelectedItems = ItemData[]
